import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_BEGIN,
  MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_SUCCESS,
  MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_FAILURE,
  MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function updateEidtSubsLock(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/updateEditSubLock`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateEidtSubsLockError() {
  return {
    type: MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_DISMISS_ERROR,
  };
}

export function useUpdateEidtSubsLock() {
  const dispatch = useDispatch();

  const { updateEidtSubsLockPending, updateEidtSubsLockError } = useSelector(
    state => ({
      updateEidtSubsLockPending: state.manageSubs.updateEidtSubsLockPending,
      updateEidtSubsLockError: state.manageSubs.updateEidtSubsLockError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(updateEidtSubsLock(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateEidtSubsLockError());
  }, [dispatch]);

  return {
    updateEidtSubsLock: boundAction,
    updateEidtSubsLockPending,
    updateEidtSubsLockError,
    dismissUpdateEidtSubsLockError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateEidtSubsLockPending: true,
        updateEidtSubsLockError: null,
      };

    case MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_SUCCESS:
      // The request is success
      return {
        ...state,
        updateEidtSubsLockPending: false,
        updateEidtSubsLockError: null,
      };

    case MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_FAILURE:
      // The request is failed
      return {
        ...state,
        updateEidtSubsLockPending: false,
        updateEidtSubsLockError: action.data.error,
      };

    case MANAGE_SUBS_UPDATE_EIDT_SUBS_LOCK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateEidtSubsLockError: null,
      };

    default:
      return state;
  }
}
